export default __webpack_public_path__ + "static/media/Gabriella 9781408300343.35846078.jpg";